import {
  IUpdateDestinations,
  TOGGLE_LOADING_DESTINATIONS,
  UPDATE_DESTINATIONS,
  UPDATE_DESTINATIONS_V2,
  IToggleLoadingDestinations,
  IUpdateDestinationsV2,
} from './types';

export function updateDestinationsActionV2(
  actionData: IUpdateDestinationsV2['actionData'],
): IUpdateDestinationsV2 {
  return {
    type: UPDATE_DESTINATIONS_V2,
    actionData,
  };
}

export function updateDestinationsAction(
  actionData: IUpdateDestinations['actionData'],
): IUpdateDestinations {
  return {
    type: UPDATE_DESTINATIONS,
    actionData,
  };
}

export function toggleLoadingDestinationsAction(
  actionData: IToggleLoadingDestinations['actionData'],
): IToggleLoadingDestinations {
  return {
    type: TOGGLE_LOADING_DESTINATIONS,
    actionData,
  };
}
